import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from './NotificationBell';

export default function Navbar() {
  const { currentUser, userProfile } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';
  const profilePath = currentUser ? `/user/${userProfile?.username || currentUser.uid}` : '/user';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <div className="navbar-logo">
            tastr<span>.</span>
          </div>
        </Link>

        {currentUser && (
          <ul className="navbar-nav">
            <li>
              <Link to="/" className={`nav-link ${isActive('/')}`}>
                <span>🍽</span> <span>Browse</span>
              </Link>
            </li>
            <li>
              <Link to="/create" className={`nav-link ${isActive('/create')}`}>
                <span>✏️</span> <span>Create</span>
              </Link>
            </li>
            <li>
              <Link to="/generate" className={`nav-link ${isActive('/generate')}`}>
                <span>✨</span> <span>AI Chef</span>
              </Link>
            </li>
            <li>
              <Link to="/plan" className={`nav-link ${isActive('/plan')}`}>
                <span>🗓</span> <span>Plan</span>
              </Link>
            </li>
            <li>
              <Link to="/my-recipes" className={`nav-link ${isActive('/my-recipes')}`}>
                <span>📖</span> <span>My Recipes</span>
              </Link>
            </li>
            <li>
              <Link to={profilePath} className={`nav-link ${isActive(profilePath)}`}>
                <span>👤</span> <span>Profile</span>
              </Link>
            </li>
            {/* "Following" removed from the nav: the same list is reachable
                from a profile's follower/following counts, and the nav was
                carrying six items. The /following route still resolves so
                existing links and bookmarks don't break. */}
            {/* The bell belongs here rather than in .navbar-actions, which is
                display:none on phones -- and a notification people can only
                see on a desktop is most of the point missed. Kept LAST so it
                sits next to Profile, and rendered caption-less so it costs
                icon width rather than a full tab slot. */}
            <li>
              <NotificationBell />
            </li>
          </ul>
        )}

        {/* Just the avatar now. The inner flex row went with Sign out -- it
            existed to space two children, and there is only one left. */}
        <div className="navbar-actions">
          {currentUser && (
            <Link to="/profile" aria-label="Your profile and settings">
              {currentUser.photoURL ? (
                <img
                  src={currentUser.photoURL}
                  alt={currentUser.displayName}
                  className="user-avatar"
                />
              ) : (
                <div className="user-avatar" style={{
                  background: 'var(--green-100)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.9rem',
                  color: 'var(--green-700)',
                  fontWeight: 600
                }}>
                  {currentUser.displayName?.[0] || 'U'}
                </div>
              )}
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
